<template>
  <div class="table-container">
    <h1>发布汇路演场次信息</h1>
    <el-form ref="form" :model="form" label-width="100px">
      <el-form-item label="活动标题">
        <el-input v-model="form.title"></el-input>
      </el-form-item>
      <el-form-item label="活动届数">
        <el-input v-model="form.stage" placeholder="活动届数，如：第一届"></el-input>
      </el-form-item>
      <el-form-item label="举办城市">
        <el-input v-model="form.city"></el-input>
      </el-form-item>

      <el-form-item label="举办地址">
        <el-input v-model="form.address" placeholder="街道地址，如：杭州滨江区"></el-input>
      </el-form-item>
      <el-form-item label="举办地址EN">
        <el-input v-model="form.addressEN" placeholder="街道地址，如：HANGZHOU BINJIANG"></el-input>
      </el-form-item>
      <el-form-item label="举办地点">
        <el-input v-model="form.position" placeholder="具体的建筑物地点，如：网商路599号网易大楼"></el-input>
      </el-form-item>
      <el-form-item label="举办地点EN">
        <el-input v-model="form.positionEN" placeholder="具体的建筑物地点，如：DISTRICT NETEASE BUILDING NO.599"></el-input>
      </el-form-item>
      <el-form-item label="人数限制">
        <el-input v-model="form.limit"></el-input>
      </el-form-item>
      <el-form-item label="举办时间">
        <el-date-picker v-model="dateRange" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
      </el-form-item>
      <p class="prompt">
        <i class="el-icon-warning"></i>
        注意：
        汇路演需要选择具体几点开始与结束，请先选择结束时间，且开始时间不可晚于结束时间。
      </p>
      <el-form-item label="开放状态">
        <el-radio-group v-model="form.status">
          <el-radio :label=1>开放</el-radio>
          <el-radio :label=0>关闭</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="视频上传">
        <el-upload :action="oss.host" :data='oss' class="one-line-upload" :on-success='headerSuccess' :on-remove='headerRemove'>
          <el-button size="small" type="primary">上传视频
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="宣传视频">
        <el-input v-model="form.header" placeholder="相同视频可以复制之前已上传后的链接粘贴于此，可节省大量时间"/>
      </el-form-item>
      <el-form-item label="上传头图">
        <el-upload :action="oss.host" :data='oss' class="one-line-upload" :on-success='footerSuccess' :on-remove='footerRemove'>
          <el-button size="small" type="primary">上传头图
            <i class="el-icon-upload el-icon--right"></i>
          </el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="头图">
        <el-input v-model="form.footer" placeholder="相同图片可以复制之前已上传后的链接粘贴于此，可节省时间"/>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click='pushData' v-if='!id'>发布信息</el-button>
        <el-button type="primary" @click='putData' plain v-if='id'>更新信息</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        title: null,
        city: null,
        address: null,
        addressEN: null,
        position: null,
        positionEN: null,
        startTime: new Date().getTime(),
        expireTime: new Date().getTime(),
        limit: null,
        status: 1,
        header: null,
        stage: null,
        footer: null
      },
      dateRange: [new Date(), new Date()],
      oss: {
        key: "",
        OSSAccessKeyId: "",
        policy: "",
        Signature: "",
        host: "",
        success_action_status: 200,
        callback: ""
      }
    };
  },
  watch: {
    id() {
      this.getData();
    }
  },
  methods: {
    headerSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.header = `${this.oss.host}/${res.result.filename}`;
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        });
      }
    },
    footerSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.footer = `${this.oss.host}/${res.result.filename}`;
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        });
      }
    },
    headerRemove() {
      this.form.header = null;
    },
    footerRemove() {
      this.form.footer = null;
    },
    getOssSign() {
      this.$http.oss_sign().then(res => {
        if (res.data.statusCode === 200) {
          this.oss.host = res.data.result.host;
          this.oss.key =
            res.data.result.dirPath + res.data.result.key + "${filename}";
          this.oss.policy = res.data.result.policy;
          this.oss.OSSAccessKeyId = res.data.result.OSSAccessKeyId;
          this.oss.Signature = res.data.result.Signature;
          this.oss.callback = res.data.result.callback;
        } else {
          this.$message({
            type: "error",
            message: "获取oss签名信息失败,请刷新重试。"
          });
        }
      });
    },
    getData(id) {
      this.$http.roadshow_detail(id).then(res => {
        if (res.data.statusCode === 200) {
          const {
            title,
            address,
            addressEN,
            position,
            positionEN,
            city,
            startTime,
            expireTime,
            status,
            limit,
            header,
            stage,
            footer
          } = res.data.result;
          this.form.title = title;
          this.form.address = address;
          this.form.addressEN = addressEN;
          this.form.position = position;
          this.form.positionEN = positionEN;
          this.form.city = city;
          this.dateRange = [startTime, expireTime];
          this.form.status = status;
          this.form.limit = limit;
          this.form.header = header;
          this.form.stage = stage;
          this.form.footer = footer;
        } else {
          this.form.title = null;
          this.form.address = null;
          this.form.addressEN = null;
          this.form.position = null;
          this.form.positionEN = null;
          this.form.city = null;
          this.dateRange = [new Date(), new Date()];
          this.form.status = 1;
          this.form.limit = null;
          this.form.stage = null;
          this.form.footer = null;
        }
      });
    },
    pushData() {
      this.form.startTime = new Date(this.dateRange[0]).getTime();
      this.form.expireTime = new Date(this.dateRange[1]).getTime();
      this.$http
        .roadshow_post({
          ...this.form
        })
        .then(res => {
          if (res.data.statusCode === 200) {
            this.$router.push("/roadshow");
            this.$message({
              message: "发布活动成功~",
              type: "success"
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    putData() {
      this.form.startTime = new Date(this.dateRange[0]).getTime();
      this.form.expireTime = new Date(this.dateRange[1]).getTime();
      this.$http
        .roadshow_put({
          id: this.id,
          ...this.form
        })
        .then(res => {
          if (res.data.statusCode === 200) {
            this.$router.push("/roadshow");
            this.$message({
              message: "更新活动成功~",
              type: "success"
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
    }
  },
  mounted() {
    this.getOssSign();
    if (this.id) {
      this.getData(this.id);
    }
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  }
};
</script>

<style scoped>
.one-line-upload {
  display: inline-block;
  vertical-align: top;
}
.prompt {
  /* width: 60%; */
  font-size: 10px;
  padding-left: 50px;
  /* text-align: center; */
  margin-top: -10px;
  margin-bottom: 10px;
  color: rgb(255, 58, 58);
}
</style>



// WEBPACK FOOTER //
// src/components/backend/roadshowpost.vue